<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hidefooter="true">
        <h3 slot="header" class="mb-0 font-weight-500">Update Platform</h3>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form @submit.prevent="submit" ref="updatePlatformForm">
                <b-row>
                    <!-- FIELD PLATFORM NAME -->
                    <b-col cols="12">
                        <b-form-group label="Platform:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'updatePlatformName'"
                            >
                            <!-- {{ updatedStatusVal }} -->
                                <b-form-input
                                    v-model="form.platform_name"
                                    required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>

                    <!-- FIELD PLATFORM CODE -->
                    <b-col cols="12">
                        <b-form-group label="Platform Code:">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'updatePlatformCode'"
                            >
                            <!-- {{ updatedStatusVal }} -->
                                <b-form-input
                                    v-model="form.platform_code"
                                    required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Update</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { Select } from "element-ui";
import '@/assets/js/formValidations.js'

export default {
    props: {
        update_platform: Boolean,
        platform_data: {
            type: Object
        },
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
    },
    computed: {
        show: {
            get() {
                return this.update_platform;
            },
            set(newVal) {
                this.$emit('update:update_platform', newVal);
            },
        },
    },
    data() {
        return {

            form: {
                platform_id: '',
                platform_code: '',
                platform_name: '',
            }
        }
    },
    async created() {
        this.$watch(
            () => this.platform_data,
            (newVal) => {
                if (newVal) {
                    this.form.platform_id = newVal.platform_id ?? '';
                    this.form.platform_name = newVal.name ?? '';
                    this.form.platform_code = newVal.code ?? '';
                }
            },
            { immediate: true }
        )

    },
    methods:{
        submit(){

            const formData = {
                'platform_id': this.form.platform_id,
                'name': this.form.platform_name,
                'code': this.form.platform_code
            }

            axios.put(services.lookup + 'platform/' + this.form.platform_id , formData, { headers: getHeader() })
            .then(res => {
                this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Updated.')
                this.$emit('closeModal')
                this.$emit('getPlatform')
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
    }
}
</script>